/**
 * Params:
 * value {string} - the current value of the field
 * allValues - The values of the entire form
 * props - Any props passed to the form
 *
 * If the value is valid, the validation function should return undefined.
 * If the value is invalid, the validation function should return an error.
 */

const required = (message: string) => (value?: string) => value ? undefined : message
const maxSize = (max: number, message: string) => (value: string) =>
  value.length > max ? message : undefined
const minSize = (min: number, message: string) => (value: string) =>
  value.length < min ? message : undefined
const exactly = (size: number, message: string) => (value: string) =>
  value.length !== size ? message : undefined
const valid = (regex: RegExp, message: string) => (value: string) =>
  regex.test(value) ? undefined : message

const validator: any | undefined =
  (fn: any, ...fns: any[]) => (value: string, error?: any) =>
    (error ? error : fn ? validator(...fns)(value, fn(value)) : undefined)

export {
  exactly,
  maxSize,
  minSize,
  required,
  valid,
  validator
}
